import studentStatusEnum from "./enums/studentStatusEnum"
import exam_enum from '@/utils/exam_enum'

// 多科科目集合
var multipleSubjectList = {
  'PRIMARY': ['1', '2', '3', '7', '10', '12'],
  'JUNIOR_MIDDLE': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '12'],
  'SENIOR_MIDDLE': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '12', '21'],
  'SECONDARY_VOCATIONAL': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '12', '21'],
}

export const networkData = {
  getGradingType,
  setImageMarks,
  setQuesImages,
  getIdentifyStudents: (list) => {
    const students = []
    list.forEach(element => {
      let student = {
        id: '',
        resultId: '',
        className: '',
        studNo: '',
        examNo: '',
        studName: '',
        totScore: 0,
        objScore: 0,
        subScore: 0,
        status: 0,
        wayFlag: null,
        amentiaFlag: 0,
        ossUrl: '',
        flag: null,
        schoolId: '',
        amentiaReason: element.amentiaReason
      }
      if (element.studentVo) {
        student.id = element.studentVo.id
        student.className = element.studentVo.className
        student.studNo = element.studentVo.seatNo
        student.examNo = element.studentVo.examNo
        student.studName = element.studentVo.studName
        student.schoolId = element.studentVo.schoolId
      }

      if (element.examResult) {
        student.resultId = element.examResult.id
        student.flag = element.examResult.flag
        student.amentiaFlag = element.examResult.amentiaFlag
        student.wayFlag = element.examResult.wayFlag
        student.ossUrl = element.examResult.ossUrl
        student.totScore = element.examResult.totScore
        student.objScore = element.examResult.objScore
        student.subScore = element.examResult.subScore
        student.status = 1
      }
      students.push(student)
    });

    return students
  },
  getExamPaperDetails: (body) => {
    const details = []
    const examResult = body.examResult
    const amentiaReason = body.amentiaReason
    body.gradingStudentDetails.forEach(item => {
      let detail = {
        choiceType: exam_enum.getCodeByKey(item.choiceType), // 试题类型
        bigNum: item.bigName,
        smallNum: item.smallName,
        ossUrl: item.ossUrl,
        url: examResult ? examResult.ossUrl : '',
        num: item.num + '',
        score: item.score, // 计算得分
        point: item.maxScore, // 满分
        maxScore: item.maxScore, // 最大分
        halfPoint: item.halfScore, // 选不全得分
        type: item.type,
        standAnswer: item.standAnswer, // 标准答案
        answer: item.answer, // 学生答案
        batchTeacherName: item.gradingTeacherNames.toString(), // 批阅教师
        halfChoiceType: body.halfChoiceType,
        halfChoiceParam: item.halfChoiceJson ? JSON.parse(item.halfChoiceJson) : null, // 选项得分组合
        optionNumInit: item.optionNumInit, // 选项数量
        optionPositions: item.optionPositions, // 选项坐标集合
        multiChooseScoringPolicy: item.multiChooseScoringPolicy, // 多选题型得分
      }
      details.push(detail)
    })
    return { details, examResult, amentiaReason }
  },
  // 转换识别标签数据
  convertIdentificationTabData: (body) => {
    const tabs = []
    const names = [studentStatusEnum.UN_UPLOAD_HAS_CHOOSE_SUBJECT.code, studentStatusEnum.UPLOAD_NOT_CHOOSE_SUBJECT.code]
    tabs.push(...body.filter(item => names.indexOf(item.code) < 0))
    tabs.splice(3, 0, ...body.filter(item => names.indexOf(item.code) >= 0))
    return tabs
  },
  // 返回历史数据科目集合
  getTodoSubjects (subjectList, isFilter) {
    const resp = {
      code: 200,
      result: { school_dic: {}, main: [] }
    }
    if (subjectList.length > 0) {
      let list = subjectList
      if (isFilter) {
        const stage = list[0].stage
        if (stage !== 'SECONDARY_VOCATIONAL') {
          list = list.filter(item => multipleSubjectList[stage].indexOf(item.subjectId + '') > -1)
        }
      }

      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        resp.result.main.push(element.id)
        resp.result.school_dic[element.id] = {
          subjectId: element.subjectId,
          dicCode: element.id,
          dicName: element.shortName
        }
      }
    }

    return resp
  },
  formatTeachers (teachers) {
    return teachers.map(s => {
      return {
        teacherId: s.id,
        teacherName: s.nickName,
        ...s
      };
    });
  }
}

function setQuesImages (ossUrl, ques) {
  if (!ques.examMarkVos) {
    ques.examMarkVos = []
  }
  ques.images = []
  const list = ossUrl.split(";")
  for (let index = 0; index < list.length; index++) {
    const url = list[index];
    const item = {
      rawWidth: 200,
      rawHeight: 200,
      src: url,
      scores: [] // 收集每张图被标记过的分数
    }
    const params = url.split(",");
    const widthPart = params.find(p => p.indexOf("w_") === 0)
    if (widthPart) {
      item.rawWidth = Number(widthPart.split("_")[1])
    }
    const heightPart = params.find(p => p.indexOf("h_") === 0)
    if (heightPart) {
      item.rawHeight = Number(heightPart.split("_")[1])
    }
    ques.images.push(item)
  }
  setImageMarks(ques, ques.examMarkVos)
}

function setImageMarks (ques, examMarkVos) {
  for (let index = 0; index < ques.images.length; index++) {
    const item = ques.images[index];
    item.scores = []
    // 恢复read页面需要的标记数据结构
    const marks = examMarkVos.filter(item => item.noteIndex === index)
    for (let mIndex = 0; mIndex < marks.length; mIndex++) {
      const mark = marks[mIndex];
      const positions = mark.position.split(',')
      if (positions.length === 2) {
        const score = {
          value: mark.showScore,
          style: {
            left: positions[0] + 'px',
            top: positions[1] + 'px',
          },
          jsonUrl: mark.writingJsonUrl,
          svgUrl: mark.writingSvgUrl,
        }
        // 生成标记分画布对象Id，这里剔除整个图层记录
        if (!score.jsonUrl) {
          if (mark.showScore > 0) {
            score.type = 'add'
            score.id = `score_plus_${Math.round(positions[0])}_${Math.round(positions[1])}`
          } else {
            score.type = 'del'
            score.id = `score_minus_${Math.round(positions[0])}_${Math.round(positions[1])}`
          }
        }
        item.scores.push(score)
      }
    }
  }
}

export const reportData = {
  // 获取六率配置
  getSixRate () {
    return [
      {
        code: 0,
        name: '高分率',
        value: 'wonderRate'
      },
      {
        code: 1,
        name: '优秀率',
        value: 'excelRate'
      },
      {
        code: 2,
        name: '良好率',
        value: 'goodRate'
      },
      {
        code: 3,
        name: '合格率',
        value: 'passRate'
      },
      {
        code: 4,
        name: '学困率',
        value: 'tiredRate'
      },
      {
        code: 5,
        name: '学弱率',
        value: 'feebleRate'
      },
    ]

  },

  // 获取导出报告配置
  getExportReportConfig () {
    return [
      {
        name: '单科校级',
        key: 'singleSchol',
        list: [
          {
            name: '一键下载',
            value: "SCHOOL_SINGLE_REPORT_ZIP"
          },
          {
            name: '班级报告',
            value: "CLASS_MERGE"
          },
          {
            name: '年级成绩单',
            value: "GRADE_SCORE"
          },
          {
            name: '基础指标分析',
            value: "GRADE_SINGLE_SIX_RATE"
          },
          {
            name: '小题分报表',
            value: "SCHOOL_QUESTION_SCORE_DETAIL",
          },
          {
            name: '小题对比分析',
            value: "SCHOOL_QUESTION_CONTRASTIVE_ANALYSIS",
          },
          {
            name: '题型分析',
            value: "GRADE_PATTERN"
          },
        ]
      },
    ]
  },

  // 获取指定配置属性的枚举列表
  getQueryItems (name) {
    const list = reportData.getExportReportConfig()
    const items = list.find(item => item.name === name)
    return items || []
  },
}

function getGradingType (type) {
  const markTypeDict = {
    FIRST: '1',
    SECOND: '2',
    THIRD: '3',
    LEADER: '4'
  }
  return markTypeDict[type]
}




// WEBPACK FOOTER //
// ./src/utils/data.js